<div
  *ngIf="label"
  class="label-value-pair-container-label"
  [ngStyle]="config?.customStyles?.label"
>
  {{ label }}
</div>
